import Select, { MultiValue } from "react-select";
import { FieldError } from "react-hook-form";
import { useLanguage } from "../context/LanguageContext";

type OptionType = {
  value: string;
  label: string;
  name?: string;
};

type Props = {
  name: string;
  label?: string;
  options: OptionType[];
  value?: OptionType[];
  onChange: (selected: OptionType[]) => void;
  error?: FieldError;
  className?: string;
  labelClass?: string;
  disabled?: boolean;
  selectClassName?: string;
};

export default function MultiSelectInput({
  name,
  label,
  options,
  value,
  onChange,
  error,
  labelClass="",
  className = "",
  selectClassName,
  disabled = false,
}: Props) {
  const { t } = useLanguage();
  return (
    <div className={`space-y-1   ${className}`}>
      {label && (
        <label htmlFor={name} className={`text-[#1E293B] text-sm w-[40%] ${labelClass}`}>
          {t(label)}
        </label>
      )}

      <div className="w-full space-y-1 ">
        <Select
          className="w-full px-0"
          inputId={name}
          isMulti
          options={options}
          value={value}
          isDisabled={disabled}
          onChange={(newValue: MultiValue<OptionType>) =>
            onChange([...newValue])
          }
            menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base: any, state: any) => ({
              ...base,
              borderRadius: "10px",
              borderColor: error ? "#f87171" : "#e5e7eb",
              boxShadow: "none",
              paddingLeft: "0rem",
              paddingRight: "0.5rem",
              fontSize: "0.875rem",
              maxHeight: "160px",
              overflow: "auto",
              backgroundColor: disabled ? "#F5F5F5" : "white",
              cursor: disabled ? "not-allowed" : "pointer",
            }),
            multiValue: (base: any) => ({
              ...base,
              backgroundColor: "#f3f4f6",
              borderRadius: "9999px",
              paddingLeft: "4px",
              paddingRight: "4px",
            }),
            placeholder: (base: any) => ({
              ...base,
              color: "#9ca3af",
            }),
            dropdownIndicator: (base: any) => ({
              ...base,
              color: "#9ca3af",
              paddingRight: "0.5rem",
            }),
          }}
        />

        {error && error.message && <p className="text-xs text-red-500">{t(error.message)}</p>}
      </div>
    </div>
  );
}
